import { applyMiddleware, createStore } from "redux";
import rootReducer from "../reducers/index";
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import { composeWithDevTools } from 'redux-devtools-extension';

const store = createStore(
	rootReducer,
	composeWithDevTools(
		applyMiddleware(thunk, logger),
	));

export default store;

// function middleware(store) {
// 	return function(next) {
// 		return function(action) {
// 			if(action.type.includes('RECEIVE')){
// 				if(action.status === "SUCCESS"){
// 					console.log(action)
// 					console.log( Object.values(action) )
// 				}else{
// 					console.log(action)
// 					console.log('server error')
// 				}
// 			}
// 			return next(action);
// 		}
// 	}
// }


// WEBPACK FOOTER //
// ./src/store/index.js